/**
 * Water Change Standard Service
 *
 * Handles water change standard by facility and bulk set.
 * Single entry for water change standard API calls.
 */

import { apiClient } from './apiClient';

/**
 * Get water change standard by facility ID.
 */
export const getWaterChangeStandardByFacility = async (facilityId) => {
  const response = await apiClient.get(`api/web-api/water_change_standard/${facilityId}/`);
  return response.data;
};

/**
 * Set water change standard for multiple facilities.
 */
export const setWaterChangeStandardForFacilities = async (facilityIds, standard) => {
  const payload = {
    facility_ids: facilityIds,
    water_change_standard: standard,
  };
  const response = await apiClient.post(
    `api/web-api/water_change_standard/water_change_standard/`,
    payload,
  );
  return response.data;
};
